import { addListener, showElement, hideElement } from "@grindex-common/helpers/domManipulation";
import PumpProductPageDom from "./pumpProductPage.dom";

function init($views) {
	const $module = $views[0];
	const dom = new PumpProductPageDom($module);

	addListener(dom.elements.linkViewElement(), "click", toggleXylectLink);
	addListener(dom.elements.optionsViewElement(), "click", toggleOptionsView);

	function toggleXylectLink(e) {
		e.preventDefault();
		showElement(dom.elements.optionsViewElement());
		hideElement(dom.elements.linkViewElement());
	}

	function toggleOptionsView() {
		hideElement(dom.elements.optionsViewElement());
		showElement(dom.elements.linkViewElement());
	}
}

export default {
	view: "pumpProductPage",
	init,
};
